import styles from './Icon.module.scss';
import Image from 'next/image';
import { forwardRef } from 'react';
import classNames from 'classnames';

const Icon = forwardRef<HTMLDivElement, { className?: string; src: string }>(
    ({ src, className }, ref) => {
        return (
            <div
                className={classNames(styles['image-container'], className)}
                ref={ref}
            >
                <Image src={src} layout="fill" className={styles.image} />
            </div>
        );
    },
);

export default Icon;
